import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { BreakpointObserver } from '@angular/cdk/layout';
import { FloatLabelType } from '@angular/material/form-field';

@Component({
  selector: 'app-loan-state-search-select',
  templateUrl: './loan-state-search-select.component.html',
  styleUrls: ['./loan-state-search-select.component.css']
})
export class LoanStateSearchSelectComponent {
  @Input() control: FormControl | string;
  @Output() emitSelectedVal: EventEmitter<any> = new EventEmitter();
  // float the label on mobile so it isn't clipped by the compact field height
  public floatLabel: FloatLabelType = 'auto';

  constructor(private breakpointObserver: BreakpointObserver) {
    this.breakpointObserver
      .observe('(max-width: 499.98px)')
      .subscribe((res) => (this.floatLabel = res.matches ? 'always' : 'auto'));
  }

  statusChange(event) {
    if(event === 0) event = '';
    this.emitSelectedVal.emit(event);
  }

  public get ctrl() {
    return this.control as FormControl;
  }

}
